import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {WelfareResultService} from '../../../../service/welfare-result.service';
import {AssetKind} from '../../../../class/asset-kind.enum';
import {AbstractAsset} from '../../../../class/abstract-asset';
import {AssetResource} from '../../../../class/lifeproject/asset-resource';

@Component({
  selector: 'app-asset-managment',
  templateUrl: './asset-management.component.html',
  styleUrls: ['./asset-management.component.css']
})
export class AssetManagementComponent implements OnInit {

  assetFilter: AssetKind;

  selectedAsset: AbstractAsset;

  showResult = false;
  showEditor = false;

  @Input()
  showHomeAssetButton = true;

  @Output()
  onAssetSelected = new EventEmitter<AssetResource>();

  constructor(private welfareService: WelfareResultService, private dialogService: NbDialogService) {
  }

  ngOnInit() {
  }

  assetResources(): AbstractAsset[] {
    const ret: AbstractAsset[] = [];
    this.welfareService.assets.forEach(value => {
      if (value.kind === this.assetFilter) {
        ret.push(value);
      }
    });
    return ret;
  }

  openDialog(dialog: TemplateRef<any>) {

    // reset view
    this.showResult = false;
    this.showEditor = false;

    this.dialogService.open(dialog).onClose.subscribe(value => {
      this.onAssetSelected.emit(value);
    });
  }

  showHomeAsset() {
    this.showResult = true;
    this.assetFilter = AssetKind.HOME;
  }

  showFinantialAsset() {
    this.showResult = true;
    this.assetFilter = AssetKind.GENERAL;
  }

  handleSelection(selectedAsset) {
    this.selectedAsset = selectedAsset;
    this.showEditor = true;
    this.showResult = false;
  }

  apply(assetResource: AssetResource, dialog: NbDialogRef<any>) {
    dialog.close(assetResource);
  }
}
